export default {"src":"/_next/static/media/germany.800d7876.svg","height":25,"width":48,"blurWidth":0,"blurHeight":0};